import { giphyCharcoal } from '@giphy/colors'
import IconComponent from 'ui/src/components/icon'
import QuickDecorate from '../../shared/quick-decorate'
import { Subheading } from '../../style'

type Props = {
    className?: string
}

const UGEDefaultEditorDecorate = ({ className }: Props) => {
    return (
        <div className={className}>
            <Subheading>
                <IconComponent color={giphyCharcoal} height={18} icon="edit" width={18} />
                Quick Decorate
            </Subheading>
            <QuickDecorate />
        </div>
    )
}

export default UGEDefaultEditorDecorate
